import React from "react";

const ToggleSwitch = ({ checked, onClick }) => {
  return (
    <button
      className={`w-24  md:w-32  md:h-14 h-10 flex items-center rounded-2xl border border-secondary/20 bg-secondary/20  
      `}
      onClick={onClick}
    >
      <div
        className={`w-10 md:w-14  md:h-10 h-8 flex items-center justify-center rounded-xl  md:text-body1 text-body2 font-ptsans font-bold transition-all  
          ${
            checked
              ? "bg-primary text-secondary ml-[51px] md:ml-16"
              : "bg-secondary/90 text-background/90  border border-secondary/20 ml-1 md:ml-1"
          }`}
      >
        {checked ? "ON" : "OFF"}
      </div>
    </button>
  );
};

export default ToggleSwitch;
